<template>
	<div
		v-if="markup.length"
		:class="[
			'html-content',
			lineClamp
		]"
		v-html="markup"
	/>
</template>

<script>
export default {
	props: {
		markup: {
			type: String,
			default: ''
		},
		expanded: {
			type: Boolean,
			default: false
		},
		useLineClamp: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		lineClamp() {
			return !this.expanded && this.useLineClamp ? 'line-clamp-1' : ''
		}
	}
}
</script>

<style scoped>
	.html-content > p {
		/* .leading-7 */
		line-height: 1.75;
	}
	.html-content > p:last-of-type {
		margin-bottom: 0;
	}
</style>
